import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";
import {EventExt} from "@COMPONENTS/product/common/popup/desktop/EventListPopup/EventListPopup";

interface EventByGoodsMonth {
	outStartDt: string;
	outDeprtTm: string;
	inArriveDt: string;
	inArrvTm: string;
	adtPrice: number;
	bafAdtPrice: number;
	airTaxAdtPrice: number;
	evCd: string;
	evNm: string;
	trCompanyNm: string;
	trCompanySnm: string;
	trTp: string;
	emphasisCd: string;
	evProgDivi: string;
	evProgDiviNm: string;
	avlilBlockQty: number;
	dayStayInfo: string;
	weblinkurl: string;
	goodsTp: string;
	accomSeq: string;
	accomNm: string;
	seatClassCd: string /* 죄석등급 */;
	seatClassNm: string /* 죄석등급 이름 */;
	couponYn: "Y" | "N" /* 쿠폰사용 여부 Y | N */;
	couponOptTy: "R" | "M" /* R: 정률 | M: 정액 */;
	couponDiscAmt: number /* 정액 */;
	couponDiscRate: number /* 정률*/;
}

/** ```
 * 상품의 월별 행사 가져오기
 *   `/prdt/api/event/by-goods/${goodsCd}/${dspSid}/${yyyymm}`
 * parameter
 *   `goodsCd` 상품코드
 *   `dspSid` 지역코드
 *   `yyyymm` 년월
 * ```*/
const key = "useEventByGoodsMonth";
const getPath = (dspSid: string, goodsCd: string, yyyymm: string): string | null => {
	if (!dspSid || !goodsCd || !yyyymm) return null;
	return `${publicRuntimeConfig.ENV_PRODUCT_API_BASEPATH}/api/event/by-goods/${goodsCd}/${dspSid}/${yyyymm}`;
};

type GoodsByMonthExt = {minPrice: number; list: EventExt[]};

/** ```
 * 상품의 월별 행사 가져오기
 *   `/prdt/api/event/by-goods/${goodsCd}/${dspSid}/${yyyymm}`
 * parameter
 *   `dspSid` 지역코드
 *   `goodsCd` 상품코드
 *   `yyyymm` 년월
 * ```*/
const useEventByGoodsMonth = (
	dspSid: string,
	goodsCd: string,
	yyyymm: string,
	options?: Partial<UseQueryOptions<Response<Partial<EventByGoodsMonth[]>>, Error, GoodsByMonthExt>>,
) =>
	useQuery({
		queryKey: [key, getPath(dspSid, goodsCd, yyyymm)],
		queryFn: () => useConfigureAxios({url: getPath(dspSid, goodsCd, yyyymm)}).then(r => r.data),
		staleTime: 1000 * 60,
		...options,
	});

export default useEventByGoodsMonth;
export {getPath};
export type {EventByGoodsMonth};
